import { render, staticRenderFns } from "./UssdCallbackDialog.vue?vue&type=template&id=6f6b915e&scoped=true&"
import script from "./UssdCallbackDialog.vue?vue&type=script&lang=ts&"
export * from "./UssdCallbackDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b915e",
  null
  
)

export default component.exports